<div class="dados-cabecalho">
  <div>
    <h1 class="dados-titulo">Dados Pessoais</h1>
    <p class="dados-subtitulo">Siga as orientações abaixo para atualizar seus dados</p>
  </div>

  <button
    #botaoAdicionar
    type="button"
    class="dados-botao dados-botao-principal"
    [disabled]="!carregado()"
    (click)="abrirModalDependente()"
  >
    Adicionar dependente
    <i-lucide name="arrow-right" size="16" aria-hidden="true"></i-lucide>
  </button>
</div>

@if (!logado()) {
  <div class="dados-alerta dados-estado-info" role="status">
    <span class="dados-alerta-icone" aria-hidden="true">
      <i-lucide name="log-in" size="18"></i-lucide>
    </span>

    <div>
      <p class="dados-alerta-titulo">Sua sessão foi encerrada.</p>
      <p class="dados-alerta-texto">
        Entre novamente para ver seus dados.
        <a class="dados-estado-link" routerLink="/login">Entrar</a>
      </p>
    </div>
  </div>
} @else if (falhou()) {
  <div class="dados-alerta dados-estado-erro" role="alert">
    <span class="dados-alerta-icone" aria-hidden="true">
      <i-lucide name="circle-alert" size="18"></i-lucide>
    </span>

    <div class="dados-estado-conteudo">
      <p class="dados-alerta-titulo">Não foi possível carregar seus dados.</p>
      <button type="button" class="dados-botao dados-botao-secundario" (click)="recarregar()">
        Tentar novamente
      </button>
    </div>
  </div>
} @else if (!carregado()) {
  <p class="dados-subtitulo" role="status" aria-live="polite">Carregando seus dados...</p>
} @else {
  <div class="dados-progresso">
    <div class="dados-progresso-topo">
      <h2 class="dados-progresso-titulo">Progresso do cadastro</h2>
      <span class="dados-progresso-total">{{ progressoTotal() }}%</span>
    </div>

    <ol class="dados-etapas">
      @for (percentual of progressoEtapas(); track $index) {
        <li class="dados-etapa" [class.dados-etapa-ativa]="percentual > 0">
          <div class="dados-etapa-topo">
            <span class="dados-etapa-nome">Etapa {{ $index + 1 }}</span>
            <span class="dados-etapa-percentual">{{ percentual }}%</span>
          </div>

          <div
            class="dados-etapa-barra"
            role="progressbar"
            [attr.aria-valuenow]="percentual"
            aria-valuemin="0"
            aria-valuemax="100"
            [attr.aria-label]="'Preenchimento da etapa ' + ($index + 1)"
          >
            <span class="dados-etapa-preenchido" [style.width.%]="percentual"></span>
          </div>
        </li>
      }
    </ol>
  </div>

  <form class="dados-formulario" (submit)="salvar($event)">
    <fieldset class="dados-bloco">
      <legend class="dados-bloco-titulo">Informações pessoais</legend>

      <div class="dados-grade dados-grade-2">
        <div class="dados-campo">
          <label class="dados-rotulo" for="dados-nome">Nome completo</label>
          <input
            id="dados-nome"
            class="dados-input"
            type="text"
            autocomplete="name"
            placeholder="Digite seu nome completo"
            [formField]="dadosForm.nomeCompleto"
          />
        </div>

        <div class="dados-campo">
          <label class="dados-rotulo" for="dados-nome-social">Nome social</label>
          <input
            id="dados-nome-social"
            class="dados-input"
            type="text"
            placeholder="Digite seu nome social"
            [formField]="dadosForm.nomeSocial"
          />
        </div>

        <div class="dados-campo">
          <label class="dados-rotulo" for="dados-genero">Gênero</label>
          <select id="dados-genero" class="dados-input" [formField]="dadosForm.genero">
            <option value="">Selecione</option>
            @for (genero of generos; track genero) {
              <option [value]="genero">{{ genero }}</option>
            }
          </select>
        </div>

        <div class="dados-campo">
          <label class="dados-rotulo" for="dados-raca">Raça/Cor</label>
          <select id="dados-raca" class="dados-input" [formField]="dadosForm.racaCor">
            <option value="">Selecione</option>
            @for (raca of racasCores; track raca) {
              <option [value]="raca">{{ raca }}</option>
            }
          </select>
        </div>
      </div>

      <div class="dados-grade dados-grade-3">
        <div class="dados-campo">
          <label class="dados-rotulo" for="dados-nascimento">Data de nascimento</label>
          <input
            id="dados-nascimento"
            class="dados-input"
            type="date"
            autocomplete="bday"
            [formField]="dadosForm.dataNascimento"
          />
        </div>

        <div class="dados-campo">
          <label class="dados-rotulo" for="dados-rg">RG</label>
          <input id="dados-rg" class="dados-input" type="text" placeholder="Digite seu RG" [formField]="dadosForm.rg" />
        </div>

        <div class="dados-campo">
          <label class="dados-rotulo" for="dados-cpf">CPF</label>
          <input
            id="dados-cpf"
            class="dados-input"
            type="text"
            inputmode="numeric"
            placeholder="000.000.000-00"
            [formField]="dadosForm.cpf"
          />
        </div>
      </div>

      <div class="dados-dependentes">
        <span class="dados-rotulo">Dependentes</span>

        @if (falhouDependentes()) {
          <div class="dados-alerta dados-estado-erro" role="alert">
            <span class="dados-alerta-icone" aria-hidden="true">
              <i-lucide name="circle-alert" size="18"></i-lucide>
            </span>

            <div class="dados-estado-conteudo">
              <p class="dados-alerta-titulo">Não foi possível carregar seus dependentes.</p>
              <button type="button" class="dados-botao dados-botao-secundario" (click)="recarregarDependentes()">
                Tentar novamente
              </button>
            </div>
          </div>
        } @else {
          @if (dependentes(); as lista) {
            @if (lista.length) {
              <ul class="dados-dependentes-lista">
                @for (dependente of lista; track dependente.codDependenteDpd) {
                  <li class="dados-dependente">
                    <span class="dados-dependente-icone" aria-hidden="true">
                      <i-lucide name="user" size="16"></i-lucide>
                    </span>

                    <span class="dados-dependente-texto">
                      <strong>{{ dependente.desNomeDpd }}</strong>
                      <span>{{ dependente.desParentescoDpd }}</span>
                    </span>

                    <button
                      type="button"
                      class="dados-dependente-remover"
                      [attr.aria-label]="'Remover dependente ' + dependente.desNomeDpd"
                      [disabled]="removendo() === dependente.codDependenteDpd"
                      (click)="removerDependente(dependente)"
                    >
                      <i-lucide name="x" size="16" aria-hidden="true"></i-lucide>
                    </button>
                  </li>
                }
              </ul>
            } @else {
              <p class="dados-dependentes-vazio">
                Nenhum dependente cadastrado. Use "Adicionar dependente" para incluir.
              </p>
            }
          } @else {
            <p class="dados-dependentes-vazio" role="status" aria-live="polite">Carregando dependentes...</p>
          }
        }
      </div>
    </fieldset>

    <fieldset class="dados-bloco">
      <legend class="dados-bloco-titulo">Endereço Residencial</legend>

      <div class="dados-grade dados-grade-endereco">
        <div class="dados-campo">
          <label class="dados-rotulo" for="dados-endereco">Endereço completo</label>
          <input
            id="dados-endereco"
            class="dados-input"
            type="text"
            autocomplete="street-address"
            placeholder="Rua, avenida, etc."
            [formField]="dadosForm.enderecoCompleto"
          />
        </div>

        <div class="dados-campo">
          <label class="dados-rotulo" for="dados-numero">Número</label>
          <input id="dados-numero" class="dados-input" type="text" placeholder="Nº" [formField]="dadosForm.numero" />
        </div>
      </div>

      <div class="dados-grade dados-grade-3">
        <div class="dados-campo">
          <label class="dados-rotulo" for="dados-complemento">Complemento</label>
          <input
            id="dados-complemento"
            class="dados-input"
            type="text"
            placeholder="Apto, bloco, etc."
            [formField]="dadosForm.complemento"
          />
        </div>

        <div class="dados-campo">
          <label class="dados-rotulo" for="dados-cep">CEP</label>
          <input
            id="dados-cep"
            class="dados-input"
            type="text"
            inputmode="numeric"
            autocomplete="postal-code"
            placeholder="00000-000"
            [formField]="dadosForm.cep"
          />
        </div>

        <div class="dados-campo">
          <label class="dados-rotulo" for="dados-bairro">Bairro</label>
          <input
            id="dados-bairro"
            class="dados-input"
            type="text"
            placeholder="Digite o bairro"
            [formField]="dadosForm.bairro"
          />
        </div>
      </div>

      <div class="dados-grade dados-grade-2">
        <div class="dados-campo">
          <label class="dados-rotulo" for="dados-estado">Estado</label>
          <select id="dados-estado" class="dados-input" [formField]="dadosForm.estado">
            <option value="">Selecione</option>
            @for (estado of estados; track estado) {
              <option [value]="estado">{{ estado }}</option>
            }
          </select>
        </div>

        <div class="dados-campo">
          <label class="dados-rotulo" for="dados-cidade">Cidade</label>
          <select id="dados-cidade" class="dados-input" [formField]="dadosForm.cidade">
            <option value="">Selecione</option>
            @for (cidade of cidades(); track cidade) {
              <option [value]="cidade">{{ cidade }}</option>
            }
          </select>
        </div>
      </div>
    </fieldset>

    <fieldset class="dados-bloco">
      <legend class="dados-bloco-titulo">Contatos</legend>

      <div class="dados-grade dados-grade-2">
        <div class="dados-campo">
          <label class="dados-rotulo" for="dados-email">E-mail</label>
          <input
            id="dados-email"
            class="dados-input"
            type="email"
            autocomplete="email"
            placeholder="nome@exemplo.com"
            [formField]="dadosForm.email"
          />
        </div>

        <div class="dados-campo">
          <label class="dados-rotulo" for="dados-senha">Senha</label>
          <input
            id="dados-senha"
            class="dados-input"
            type="password"
            autocomplete="new-password"
            placeholder="••••••••"
            [formField]="dadosForm.senha"
          />
        </div>
      </div>

      <div class="dados-grade dados-grade-3">
        <div class="dados-campo">
          <label class="dados-rotulo" for="dados-tel-residencial">Telefone residencial</label>
          <input
            id="dados-tel-residencial"
            class="dados-input"
            type="tel"
            placeholder="(00) 0000-0000"
            [formField]="dadosForm.telefoneResidencial"
          />
        </div>

        <div class="dados-campo">
          <label class="dados-rotulo" for="dados-tel-01">Telefone celular 01</label>
          <input
            id="dados-tel-01"
            class="dados-input"
            type="tel"
            autocomplete="tel"
            placeholder="(00) 00000-0000"
            [formField]="dadosForm.telefoneCelular01"
          />
        </div>

        <div class="dados-campo">
          <label class="dados-rotulo" for="dados-tel-02">Telefone celular 02</label>
          <input
            id="dados-tel-02"
            class="dados-input"
            type="tel"
            placeholder="(00) 00000-0000"
            [formField]="dadosForm.telefoneCelular02"
          />
        </div>
      </div>
    </fieldset>

    <div class="dados-alerta" role="note">
      <span class="dados-alerta-icone" aria-hidden="true">
        <i-lucide name="mail" size="18"></i-lucide>
      </span>

      <div>
        <p class="dados-alerta-titulo">Confirmação de envio de e-mail</p>
        <p class="dados-alerta-texto">
          Ao alterar o e-mail, enviaremos uma confirmação para o novo endereço. Verifique sua caixa de entrada
          (e a pasta Spam/Lixo Eletrônico) para confirmar a mudança.
        </p>
      </div>
    </div>

    <div class="dados-acoes">
      <button type="submit" class="dados-botao dados-botao-principal">
        Salvar alterações
        <i-lucide name="check" size="16" aria-hidden="true"></i-lucide>
      </button>
    </div>
  </form>
}

<!-- Na raiz, fora do formulário principal: formulários não se aninham. -->
<dialog
  #modalDependente
  class="dados-modal"
  aria-labelledby="dados-modal-titulo"
  (cancel)="aoCancelarModal($event)"
>
  <form class="dados-modal-conteudo" novalidate (submit)="salvarDependente($event)">
    <div class="dados-modal-topo">
      <div>
        <h2 class="dados-modal-titulo" id="dados-modal-titulo">Adicionar dependente</h2>
        <p class="dados-modal-texto">Informe os dados de quem será vinculado ao seu cadastro.</p>
      </div>

      <button
        type="button"
        class="dados-modal-fechar"
        aria-label="Fechar"
        [disabled]="salvando()"
        (click)="fecharModalDependente()"
      >
        <i-lucide name="x" size="18" aria-hidden="true"></i-lucide>
      </button>
    </div>

    <div class="dados-grade dados-grade-2">
      <div class="dados-campo">
        <label class="dados-rotulo" for="dep-nome">Nome completo *</label>
        <input
          id="dep-nome"
          class="dados-input"
          type="text"
          autofocus
          aria-required="true"
          placeholder="Digite o nome completo"
          [attr.aria-invalid]="erroDependente('nomeCompleto') ? 'true' : null"
          [attr.aria-describedby]="erroDependente('nomeCompleto') ? 'dep-nome-erro' : null"
          [formField]="dependenteForm.nomeCompleto"
        />
        @if (erroDependente('nomeCompleto'); as erro) {
          <p class="dados-erro" id="dep-nome-erro">{{ erro }}</p>
        }
      </div>

      <div class="dados-campo">
        <label class="dados-rotulo" for="dep-nome-social">Nome social</label>
        <input
          id="dep-nome-social"
          class="dados-input"
          type="text"
          placeholder="Digite o nome social"
          [attr.aria-invalid]="erroDependente('nomeSocial') ? 'true' : null"
          [attr.aria-describedby]="erroDependente('nomeSocial') ? 'dep-nome-social-erro' : null"
          [formField]="dependenteForm.nomeSocial"
        />
        @if (erroDependente('nomeSocial'); as erro) {
          <p class="dados-erro" id="dep-nome-social-erro">{{ erro }}</p>
        }
      </div>

      <div class="dados-campo">
        <label class="dados-rotulo" for="dep-parentesco">Parentesco *</label>
        <select
          id="dep-parentesco"
          class="dados-input"
          aria-required="true"
          [attr.aria-invalid]="erroDependente('parentesco') ? 'true' : null"
          [attr.aria-describedby]="erroDependente('parentesco') ? 'dep-parentesco-erro' : null"
          [formField]="dependenteForm.parentesco"
        >
          <option value="">Selecione</option>
          @for (parentesco of parentescos; track parentesco) {
            <option [value]="parentesco">{{ parentesco }}</option>
          }
        </select>
        @if (erroDependente('parentesco'); as erro) {
          <p class="dados-erro" id="dep-parentesco-erro">{{ erro }}</p>
        }
      </div>

      <div class="dados-campo">
        <label class="dados-rotulo" for="dep-nascimento">Data de nascimento *</label>
        <input
          id="dep-nascimento"
          class="dados-input"
          type="date"
          aria-required="true"
          [attr.max]="hoje"
          [attr.aria-invalid]="erroDependente('dataNascimento') ? 'true' : null"
          [attr.aria-describedby]="erroDependente('dataNascimento') ? 'dep-nascimento-erro' : null"
          [formField]="dependenteForm.dataNascimento"
        />
        @if (erroDependente('dataNascimento'); as erro) {
          <p class="dados-erro" id="dep-nascimento-erro">{{ erro }}</p>
        }
      </div>

      <div class="dados-campo">
        <label class="dados-rotulo" for="dep-genero">Gênero</label>
        <select id="dep-genero" class="dados-input" [formField]="dependenteForm.genero">
          <option value="">Selecione</option>
          @for (genero of generos; track genero) {
            <option [value]="genero">{{ genero }}</option>
          }
        </select>
      </div>

      <div class="dados-campo">
        <label class="dados-rotulo" for="dep-raca">Raça/Cor</label>
        <select id="dep-raca" class="dados-input" [formField]="dependenteForm.racaCor">
          <option value="">Selecione</option>
          @for (raca of racasCores; track raca) {
            <option [value]="raca">{{ raca }}</option>
          }
        </select>
      </div>

      <div class="dados-campo">
        <label class="dados-rotulo" for="dep-rg">RG</label>
        <input
          id="dep-rg"
          class="dados-input"
          type="text"
          placeholder="Digite o RG"
          [attr.aria-invalid]="erroDependente('rg') ? 'true' : null"
          [attr.aria-describedby]="erroDependente('rg') ? 'dep-rg-erro' : null"
          [formField]="dependenteForm.rg"
        />
        @if (erroDependente('rg'); as erro) {
          <p class="dados-erro" id="dep-rg-erro">{{ erro }}</p>
        }
      </div>

      <div class="dados-campo">
        <label class="dados-rotulo" for="dep-cpf">CPF</label>
        <input
          id="dep-cpf"
          class="dados-input"
          type="text"
          inputmode="numeric"
          placeholder="000.000.000-00"
          mask="000.000.000-00"
          [attr.aria-invalid]="erroDependente('cpf') ? 'true' : null"
          [attr.aria-describedby]="erroDependente('cpf') ? 'dep-cpf-erro' : null"
          [formField]="dependenteForm.cpf"
        />
        @if (erroDependente('cpf'); as erro) {
          <p class="dados-erro" id="dep-cpf-erro">{{ erro }}</p>
        }
      </div>
    </div>

    <!-- O erro do envio fica AQUI: com o modal aberto, um alerta abriria atrás dele. -->
    @if (erroModal(); as erro) {
      <div class="dados-alerta dados-estado-erro" role="alert">
        <span class="dados-alerta-icone" aria-hidden="true">
          <i-lucide name="circle-alert" size="18"></i-lucide>
        </span>

        <div>
          <p class="dados-alerta-titulo">{{ erro.mensagem }}</p>
          @if (erro.detalhes.length) {
            <ul class="dados-modal-detalhes">
              @for (detalhe of erro.detalhes; track detalhe) {
                <li>{{ detalhe }}</li>
              }
            </ul>
          }
        </div>
      </div>
    }

    <div class="dados-modal-acoes">
      <button
        type="button"
        class="dados-botao dados-botao-secundario"
        [disabled]="salvando()"
        (click)="fecharModalDependente()"
      >
        Cancelar
      </button>

      <button type="submit" class="dados-botao dados-botao-principal" [disabled]="salvando()">
        {{ salvando() ? 'Salvando...' : 'Salvar dependente' }}
        <i-lucide name="check" size="16" aria-hidden="true"></i-lucide>
      </button>
    </div>
  </form>
</dialog>
